import {
    FC,
    SignalPropsHandler,
    ExtendProps,
    getProp,
    PointLike,
    copyPointData,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {BitmapText, TextStyleAlign} from 'pixi.js';
import {$Container, ContainerProps, ExtendContainerProps} from './Container';

export type BitmapTextProps = ExtendContainerProps<{
    text: string | number;
    fontName: string;
    fontSize?: number;
    tint?: number;
    align?: TextStyleAlign;
    letterSpacing?: number;
    maxWidth?: number;
    anchor?: PointLike;
}, BitmapText>;

const TEXT_PROPS_LIST = ['text', 'fontName', 'fontSize', 'tint', 'align', 'letterSpacing', 'maxWidth', 'anchor'] as const;
const propsHandler = new SignalPropsHandler<BitmapTextProps, BitmapText>()
    .propsToHandle(TEXT_PROPS_LIST)
    .setHandlerFor('anchor', (val, obj) => copyPointData(val, obj.anchor))
    .setHandlerFor('text', (val, obj) => {
        obj.text = val.toString();
        applyMaxWidth(obj.maxWidth, obj);
    });

/**
 * Basic Pixi BitmapText component wrapper.
 */
export const $BitmapText: FC<BitmapTextProps> = (props) => {
    const instance = props.instance ??= createInstance(props);
    const unsubscribe = propsHandler.apply(props, instance);

    instance.on('destroyed', unsubscribe);

    const maxWidth = getProp(props.maxWidth) as number;
    applyMaxWidth(maxWidth, instance);

    return $Container(props as ContainerProps);
};

const createInstance = (props: BitmapTextProps) => {
    const text = getProp(props.text).toString();
    const fontName = getProp(props.fontName);

    return new BitmapText(text, {fontName});
};

const applyMaxWidth = (maxWidth: number, obj: BitmapText): void => {

    if (maxWidth > 0 && obj.textWidth > maxWidth) {
        const scale = maxWidth / obj.textWidth;

        obj.scale.set(scale);
    };
};

// Helper types
export type ExtendBitmapTextPropsSimple<T> = T & BitmapTextProps;
export type ExtendBitmapTextProps<T> = ExtendProps<T, BitmapTextProps, BitmapText>;
